import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { InventoryForReturnSummaryDto, InventoryListing } from '~/models/modules/inventory';
import { ApiServiceBase, API_NAMES } from '~/services/api';
import { SecurityService } from '~/services/security.service';
import { orderBy } from '@progress/kendo-data-query';

@Injectable({ providedIn: 'root' })
export class InventoriesService extends ApiServiceBase {
  constructor(injector: Injector, private http: HttpClient, private _securityService: SecurityService,) {
    super(injector);
    this.setBase(API_NAMES.stocks);
  }

  getInventoryListing(siteId: number) {

    return this.http.get<InventoryForReturnSummaryDto[]>(`${this._url()}/site/${siteId}`);
  }
  getInventoryListing2(siteId: number, paramsObj?: any, withoutavaliability: boolean = false) {
    let params = createHttpParams(paramsObj);
    if (siteId == null) {
      siteId = 0;
    }
    return this.http.get<InventoryForReturnSummaryDto[]>(`${this._url()}/WithPagingSite/${siteId}/${withoutavaliability}`, { params, observe: 'response' });
  }
  getInventoryListing3(siteId: number, paramsObj?: any, withoutavaliability: boolean = false) {
    if (!siteId)
      siteId = 0;
    let params = createHttpParams(paramsObj);
    return this.http.get<InventoryForReturnSummaryDto[]>(`${this._url()}/WithPagingSite3/${siteId}/${withoutavaliability}`, { params, observe: 'response' });
  }
  GetByInventoryNumberAndSiteAndLocationId(siteId: number, inventoryNumber: string, locationId?: number) {
    if (locationId)
      return this.http.get<InventoryForReturnSummaryDto[]>(`${this._url()}/GetByInventoryNumberAndSiteAndLocationId/${siteId}/${inventoryNumber}/${locationId}`);
    else
      return this.http.get<InventoryForReturnSummaryDto[]>(`${this._url()}/GetByInventoryNumberAndSiteAndLocationId/${siteId}/${inventoryNumber}`);
  }

  getInventoryListingForReturn(siteId: number, customerId: number, salesOrderId: number = null) {
    return this.http.get<InventoryListing[]>(`${this._url()}/inventoryForReturn/${siteId}/${customerId}/${salesOrderId}`);
  }
  getInventoryListingForReturnWithPaging(siteId: number, customerId: number, salesOrderId: number = null) {
    return this.http.get<InventoryListing[]>(`${this._url()}/inventoryForReturnWithPaging/${siteId}/${customerId}/${salesOrderId}`);
  }


  getInventoryById(id: number, salesOrderId: number = null, iswithoutavailability: boolean = null, siteId: number = null) {
    if (salesOrderId === null && salesOrderId <= 0 && id > 0 && iswithoutavailability === null) {
      return this.http.get<any>(this._url(`/ForSalesOrder/${id}`));
    }
    else {
      return this.http.get<any>(salesOrderId !== null && salesOrderId > 0 && id > 0 && iswithoutavailability === null
        ? this._url(`/ForSalesOrder/${id}/${salesOrderId}/${siteId}`)
        : this._url(`/getwithoutavalibility/${id}/${iswithoutavailability}`));
    }

  }




  getreturnById(siteId: number, customerId: number, salesOrderId: number = null, id: number = null) {
    return this.http.get<InventoryListing[]>(`${this._url()}/inventoryForReturn/${siteId}/${customerId}/${salesOrderId}/${id}`);
  }
  getInventoryByIdAndLocation(stockItemid: number, locationid: number, inventorynumber: string) {
    return this.http.get<any>(this._url(`/${stockItemid}/${locationid}/${inventorynumber}`));
  }

  getInventoryListIds(ids: string) {
    return this.http.post<any>(
      this._url('/getallids'),
      JSON.stringify(ids),
      { headers: { 'Content-Type': 'application/json' } }
    );
  }

  getInventoryListIdsParam(paramsObj?: any) {
    return this.http.post<any>(this._url(`/getallidsparams/`), paramsObj);
  }

  getInventoryListIds2(ids: any) {
    return this.http.post<any>(this._url(`/getallids2`), ids);
  }

  getInventoryListbyNumberAndLocation(stockLocationModel: any) {
    return this.http.post<any[]>(this._url(`/getlistbyinventorynumberandlocation`), stockLocationModel, { observe: 'response' }).pipe(map(augmentPaging));

  }

  getInventories(paramsObj?: any, model?: any, screenSiteId?: number) {
    if (this._securityService.currentUser.isEnterprise) {
      return this.getEnterpriseInventories(paramsObj, model);
    }
    else {
      model = {
        ...model, modelParam: { ...paramsObj }
      }

      return this.getAppliaceInventories(paramsObj, model, screenSiteId);
    }
  }

  getEnterpriseInventories(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http.post<any[]>(this._url(`/grid-data`), model, { params, observe: 'response' }).pipe(map(augmentPaging));
  }

  getAppliaceInventories(paramsObj?: any, model?: any, screenSiteId?: number) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    paramsObj.screenSiteId = screenSiteId;
    let params = createHttpParams(paramsObj);

    return this.http.post<any[]>(this._url(`/grid-data-appliance`), model, { params, observe: 'response' }).pipe(map(augmentPaging));
  }

  GetInventoriesByUOM(unitOfMeasureId: number, model: any) {
    return this.http.post<any[]>(this._url(`/UnitOfMeasures/${unitOfMeasureId}/grid-data`), model, { observe: 'response' }).pipe(map(augmentPaging));
  }



  getInventoryByStockItem(stockItemId: number, model: any) {
    return this.http.post<any[]>(this._url(`/StockItems/${stockItemId}/grid-data`), model, { observe: 'response' }).pipe(map(augmentPaging));
  }

  GetStockItemNumberPerQuantityOnHand(top: number = 10) {
    return this.client.get(this._url(`/GetStockItemNumberPerQuantityOnHand/${top}`));
  }

  GetInventoryTypePerQuantityOnHand(top: number = 10) {
    return this.client.get(this._url(`/GetInventoryTypePerQuantityOnHand/${top}`));
  }

  GetReceivedQuantityPerYears(top: number = 10) {
    return this.client.get(this._url(`/GetReceivedQuantityPerYears/${top}`));
  }

  GetReceivedQuantityPerMonths(top: number = 10) {
    return this.client.get(this._url(`/GetReceivedQuantityPerMonths/${top}`));
  }

  GetReceivedQuantityPerDays(top: number = 10) {
    return this.client.get(this._url(`/GetReceivedQuantityPerDays/${top}`));
  }

  GetStockItemsCountPerCategory(top: number = 10) {
    return this.client.get(this._url(`/GetStockItemsCountPerCategory/${top}`));
  }

  GetStockItemsQunatityOnHandPerCategory(top: number = 10) {
    return this.client.get(this._url(`/GetStockItemsQunatityOnHandPerCategory/${top}`));
  }

  GetStockItemNumberQuantityBelowMinimum(top: number = 10) {
    return this.client.get(this._url(`/GetStockItemNumberQuantityBelowMinimum/${top}`));
  }

  GetStockItemNumberQuantityAboveMaximum(top: number = 10) {
    return this.client.get(this._url(`/GetStockItemNumberQuantityAboveMaximum/${top}`));
  }

  GetStockItemsCountPerCostType(top: number = 10) {
    return this.client.get(this._url(`/GetStockItemsCountPerCostType/${top}`));
  }

  GetStockItemsQuantityOnHandPerCostType(top: number = 10) {
    return this.client.get(this._url(`/GetStockItemsQuantityOnHandPerCostType/${top}`));
  }

  GetStockItemQuantityOnHandPerCostRange(top: number = 10) {
    return this.client.get(this._url(`/GetStockItemQuantityOnHandPerCostRange/${top}`));
  }

  GetStockItemQuantityOnHandPerPriceRange(top: number = 10) {
    return this.client.get(this._url(`/GetStockItemQuantityOnHandPerPriceRange/${top}`));
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/Inventories${v}`);
  }
}
